import React from "react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";

const LanguageBar = () => {
  const { i18n } = useTranslation();

  // ฟังก์ชันเปลี่ยนภาษา
  const toggleLanguage = () => {
    // เปลี่ยนภาษาเมื่อกด
    const newLang = i18n.language === "th" ? "en" : "th";
    i18n.changeLanguage(newLang); // เปลี่ยนภาษา
  };

  // ฟังก์ชันตรวจสอบว่าเป็นภาษาที่กำหนดหรือไม่
  const isActive = (code) => i18n.language === code;

  return (
    <div className="w-25 h-10 p-1 rounded-full">
      <Link
        to="#"
        onClick={toggleLanguage} // เปลี่ยนภาษาเมื่อคลิก
        className="w-full h-full flex justify-center items-center gap-x-1 text-lg font-normal cursor-pointer"
      >
        <div className="w-26 h-9 p-1 rounded-full bg-primary-dark text-primary-text-dark pr-5 pl-5">
          <div className="w-full h-full flex justify-center items-center gap-x-1 text-lg font-normal cursor-pointer">
            <span
              className={isActive("th") ? "text-secondary-text-invert" : ""}
            >
              ไทย
            </span>
            <span className="font-thin">|</span>
            <span
              className={isActive("en") ? "text-secondary-text-invert" : ""}
            >
              EN
            </span>
          </div>
        </div>
      </Link>
    </div>
  );
};

export default LanguageBar;
